import crypto from 'crypto-js';
import {JWP_API_SECRET, JWP_PLAYER} from "../constants";

const Time = new Date();

function signed_url(
    path,
    expires = 600000,
    secret = `${String(JWP_API_SECRET)}`,
    host = 'https://cdn.jwplayer.com'
) {
    const base = `${path}:${expires}:${secret}`;
    const signature = crypto.MD5(base);
    return `${host}/${path}?exp=${expires}&sig=${signature}`;
}

function get_response() {
    const path = `libraries/${String(JWP_PLAYER)}.js`;
    const expires = Math.ceil((Time.getTime() + 3600) / 300) * 300;
    return signed_url(path, expires);
}
const jwpUrl = get_response()

export { jwpUrl }